import { Modal } from "semantic-ui-react";
import CircularProgress from "@mui/material/CircularProgress";
// Style
import "./style.scss";
import { StackIcon } from "shared/ui";

const ModalWindow = (props) => {
  return (
    <Modal
      className={`modal-window ${props.classes ?? ""}`}
      open={!!props.open}
      onClose={props.closeHandler}
      closeOnDimmerClick={props.closeOnDimmerClick}
    >
      <div className="modal-wrap">
        <div className="modal-close" onClick={props.closeHandler}>
          <StackIcon
            width={15}
            icon="close"
            label="Close"
            stroke="currentcolor"
          />
        </div>
        <div className="modal-content">
          {props.children ? (
            props.children
          ) : (
            <>
              <p className="title">{props.title}</p>
              {props.content.split("<br>").map((item, index) => (
                <p key={index}>{item}</p>
              ))}
            </>
          )}
        </div>
        {(props.closeText || props.confirmText) && (
          <div className="modal-actions">
            <button className="modal-button alt" onClick={props.closeHandler}>
              {props.closeText}
            </button>
              <button
                  className="modal-button"
                  disabled={!!props.loading}
                  onClick={props.loading ? undefined : props.confirmHandler}
              >
              {!props.loading ? (
                props.confirmText
              ) : (
                <CircularProgress
                  size={20}
                  classes={{ colorPrimary: "material-loader-accent" }}
                />
              )}
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ModalWindow;
